import classNames from "classnames";
import _ from 'lodash';
import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Form, TextArea } from 'semantic-ui-react';
import styled from 'styled-components';

export const TextAreaSc = styled(TextArea)`
  width: 100%;

  .ui.form &.textarea,
  .field .ui.textarea & {
    padding: 5px;
  }

  .ui.form &.textarea.error,
  .field .ui.textarea.error & {
    background-color: #fff6f6;
    border-color: #e0b4b4;
    color: #9f3a38;
  }

  &:disabled {
    cursor: default;
    pointer-events: none;
    opacity: .45;
    resize: none !important;
  }
`;

interface ExtendedFieldRenderProps extends FieldRenderProps {
  rows?: number
}

const FinalFormTextArea = (props: ExtendedFieldRenderProps) => {

  const {
    input,
    meta: {touched, error},
    rows = 5,
    ...restProps
  } = props;

  return (
      <Form.Field>
        <div className={classNames(
            "ui", "form", "textarea", {"error": !!(touched && error)})}
        >
          <TextAreaSc
              {...input}
              {..._.omit(restProps, ["fluid"])}
              rows={rows}
          />
        </div>
      </Form.Field>
  )

};

export default FinalFormTextArea;
